import React from 'react';
import './MyLoading.css';

const MyLoading = ({ size = 'medium', color = '#007bff', className = '' }) => {
  const sizeClass = `loading-${size}`;
  
  return (
    <div className={`loading-spinner ${sizeClass} ${className}`}>
      <div className="spinner" style={{ borderTopColor: color }}></div>
    </div>
  );
};

export default MyLoading;